import { render, staticRenderFns } from "./BoardAgileSprint.vue?vue&type=template&id=55106d50&"
import script from "./BoardAgileSprint.vue?vue&type=script&lang=js&"
export * from "./BoardAgileSprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports